import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { UI_HEIGHT } from '../Common/constants';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, Table } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';

class CustomerItems extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            rows: [],
            selectedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,
        };
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        this.setState({rows: this.props.items});
        window.addEventListener('resize', this.handleResize);
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once products are ready, reset state.

    componentWillReceiveProps(nextProps) {
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton});
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseTemplate();
        this.context.router.push('/purchaseTemplate/new')
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }

            // Handle the row select function

            const onRowsSelected = (rows) => {
                 let newRows = this.state.rows;
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = true;
                 });
                 let selectedRows = [...this.state.selectedRows];
                 selectedRows = selectedRows.concat(rows.map(r => {return r.row}));
                 this.setState({selectedRows: selectedRows});
            }

             const onRowsDeselected = (rows) => {
                 let newRows = this.state.rows;
                 rows.map (r => {
                   newRows[r.rowIdx].isSelected = false;
                 });
                 let selectedRows = [...this.state.selectedRows];
                 selectedRows = selectedRows.filter(function(obj){
                   return obj.isSelected == true;
                 });
                 this.setState({selectedRows: selectedRows});
             }

            // Column difinition

            const columns = [
                {
                    key: 'ProductNum',
                    name: <Translate value="product_num" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'ProductName',
                    name: <Translate value="product_name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                },
                {
                    key: 'ProductDescription',
                    name: <Translate value="product_description" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                },
                {
                    key: 'UnitPrice',
                    name: <Translate value="unit_price" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                },
                {
                    key: 'TotalPrice',
                    name: <Translate value="total_price" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="CustomerItems-dataGrid1">
                    <ReactDataGrid
                        rowKey='ProductNum'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={300}
                        enableRowSelect='multi'
                        rowSelection={{
                          showCheckbox: true,
                          enableShiftSelect: true,
                          onRowsSelected: onRowsSelected,
                          onRowsDeselected: onRowsDeselected,
                          selectBy: {
                           isSelectedKey: 'isSelected'
                          }
                       }}
                        />
                </div></Col></Row>
            )
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        return (
            <ContentWrapper>
                {this.renderTable() }
                <br/>
                <Row>
                  <Button
                      bsStyle="primary"
                      className="marginLeftStyle"
                      onClick={() => { this.props.addItem(this.state.selectedRows) } }
                  >
                      <em className="fa fa-plus marginRightStyle" /><Translate value="add_selected_items" />
                  </Button>
                </Row>
            </ContentWrapper>
        );
    }
}



export default CustomerItems;



// WEBPACK FOOTER //
// ./master/jsx/components/Returns/customerItems.jsx